import type { PackagingMasterDataSearchResult } from '../../domain/model/packaging/PackagingMasterData.types';
import type {
    ApiPackagingMasterDataSearchResponse,
    ApiPackagingMasterDataSearchResult,
} from './transportExecution.packagingMasterData.schema';

const toPackagingMasterDataSearchResult = (
    source: ApiPackagingMasterDataSearchResult
): PackagingMasterDataSearchResult => {
    const base = {
        code: source.code,
        description: source.description ?? undefined,
    };

    if (source.type === 'item') {
        return { ...base, type: source.type };
    }

    return {
        ...base,
        type: source.type,
        items: source.items.map(item => ({
            quantity: item.quantity,
            packagingItem: {
                code: item.packaging_item.code,
                description: item.packaging_item.description ?? undefined,
            },
        })),
    };
};

export const toPackagingMasterDataSearchResults = (
    source: ApiPackagingMasterDataSearchResponse
): PackagingMasterDataSearchResult[] => {
    const mapped = source.items.map(toPackagingMasterDataSearchResult);
    return [...mapped.filter(item => item.type === 'bundle'), ...mapped.filter(item => item.type === 'item')];
};
